import { SocketMessageCode } from "~/shared/enum";
import type { SocketMessageType } from "~/shared/interfaces/socket.interface";

export const usePush = () => {
    if (import.meta.client) {
        const { t } = useI18n();
        const { $io, $bus, $config } = useNuxtApp();
        const { authentication, logout, principal, setPrincipal, isAuthenticated } = usePrincipal();
        const { setprematchCategory, setInplayCategory, setEprematchCategory, setEInplayCategory, setAlert } =
            useStore();

        let heartbeatInterval: any = null;

        if (authentication.value.jwt) {
            console.log(authentication.value.jwt);
            $io.auth = { token: authentication.value.jwt };
        }
        $io.connect();
        $io.on("connect", () => {
            console.log("socket connected");
        });

        $io.on("disconnect", (err: any) => {
            console.log("socket disconnected", err);
            $io.disconnect();
        });

        $io.on($config.public.socket.clientChannel, (data: SocketMessageType) => {
            if (data && Object.values(SocketMessageCode).some((x) => x == data.code) && data.body) {
                const { code, body } = data;
                if (code == SocketMessageCode.Prematch_Category) {
                    setprematchCategory(body);
                } else if (code == SocketMessageCode.Inplay_Category) {
                    setInplayCategory(body);
                } else if (code == SocketMessageCode.EPrematch_Category) {
                    setEprematchCategory(body);
                } else if (code == SocketMessageCode.EInplay_Category) {
                    setEInplayCategory(body);
                } else if (code == SocketMessageCode.Inplay_Fixture) {
                    $bus.$emit(SocketMessageCode.Inplay_Fixture, body);
                } else if (code == SocketMessageCode.Prematch_Fixture) {
                    $bus.$emit(SocketMessageCode.Prematch_Fixture, body);
                } else if (code == SocketMessageCode.Inplay_LiveScore) {
                    $bus.$emit(SocketMessageCode.Inplay_LiveScore, body);
                } else if (code == SocketMessageCode.Inplay_Market) {
                    $bus.$emit(SocketMessageCode.Inplay_Market, body);
                } else if (code == SocketMessageCode.Prematch_Market) {
                    $bus.$emit(SocketMessageCode.Prematch_Market, body);
                } else if (code == SocketMessageCode.UserBalance) {
                    const { card_money, cash, casino, point } = body;
                    setPrincipal({
                        ...principal.value,
                        card_money,
                        cash,
                        casino,
                        point,
                    });
                } else if (code == SocketMessageCode.MiniGame) {
                    $bus.$emit(SocketMessageCode.MiniGame, body);
                } else if (code == SocketMessageCode.ReloadMiniGameBetLog) {
                    $bus.$emit(SocketMessageCode.ReloadMiniGameBetLog, body);
                } else if (code == SocketMessageCode.ReloadVSportsBetLog) {
                    $bus.$emit(SocketMessageCode.ReloadVSportsBetLog, body);
                } else if (code == SocketMessageCode.Inquiry) {
                    setAlert({
                        isShow: true,
                        data: {
                            type: "success",
                            message: `${t(`inquiry solved`)}`,
                        },
                    });
                    $bus.$emit(SocketMessageCode.Inquiry, body);
                } else if (code == SocketMessageCode.Notice) {
                    setAlert({
                        isShow: true,
                        data: {
                            type: "success",
                            message: `${t("new notice")}`,
                        },
                    });
                    $bus.$emit(SocketMessageCode.Notice, body);
                } else if (code == SocketMessageCode.Message) {
                    setPrincipal({ ...principal.value, unreadMessageCount: body.unread_count });
                    // if (body.unread_count > 0) {
                    //     setAlert({
                    //         isShow: true,
                    //         type: 'unread-message',
                    //         data: {
                    //             type: 'warning',
                    //             message: t('new message')
                    //         }
                    //     });
                    // }
                    $bus.$emit(SocketMessageCode.Message, body);
                } else if (code == SocketMessageCode.Deposit) {
                    if (body?.status == 1) {
                        setAlert({
                            isShow: true,
                            data: {
                                type: "success",
                                message: t("deposit approved"),
                            },
                        });
                    } else if (body?.status == 2) {
                        setAlert({
                            isShow: true,
                            data: {
                                type: "success",
                                message: t("deposit disapproved"),
                            },
                        });
                    }
                    $bus.$emit(SocketMessageCode.Deposit, body);
                } else if (code == SocketMessageCode.Withdraw) {
                    if (body?.status == 1) {
                        setAlert({
                            isShow: true,
                            data: {
                                type: "success",
                                message: t("withdraw approved"),
                            },
                        });
                    } else if (body?.status == 2) {
                        setAlert({
                            isShow: true,
                            data: {
                                type: "success",
                                message: t("withdraw disapproved"),
                            },
                        });
                    }
                    $bus.$emit(SocketMessageCode.Withdraw, body);
                } else if (code == SocketMessageCode.Logout) {
                    if (body.reason == "inactive_long_time") {
                        setAlert({
                            isShow: true,
                            data: {
                                type: "warning",
                                message: "오랜 시간동안 활동이 없어 로그아웃되었습니다.",
                            },
                        });
                    } else if (body.reason == "duplicate_login") {
                        setAlert({
                            isShow: true,
                            data: {
                                type: "warning",
                                message: "중복 로그인으로 인하여 로그아웃되었습니다.",
                            },
                        });
                    } else if (body.reason == "force_logout") {
                        setAlert({
                            isShow: true,
                            data: {
                                type: "warning",
                                message: "관리자에 의하여 강제 로그아웃 되었습니다.",
                            },
                        });
                    }
                    logout();
                } else if (code == SocketMessageCode.Withdraw) {
                    // 출금 관련 메시지 처리
                    console.log("출금 메시지 수신:", body);
                    $bus.$emit(SocketMessageCode.Withdraw, body);

                    // 출금 상태에 따른 알림 표시
                    if (body.status === "approved") {
                        setAlert({
                            isShow: true,
                            data: {
                                type: "success",
                                message: "출금이 승인되었습니다.",
                            },
                        });
                    } else if (body.status === "rejected") {
                        setAlert({
                            isShow: true,
                            data: {
                                type: "error",
                                message: "출금이 거절되었습니다.",
                            },
                        });
                    }
                } else if (code == SocketMessageCode.Deposit) {
                    // 입금 관련 메시지 처리
                    console.log("입금 메시지 수신:", body);
                    $bus.$emit(SocketMessageCode.Deposit, body);

                    // 입금 상태에 따른 알림 표시
                    if (body.status === "approved") {
                        setAlert({
                            isShow: true,
                            data: {
                                type: "success",
                                message: "입금이 승인되었습니다.",
                            },
                        });
                    }
                } else if (code == SocketMessageCode.CouponUsage) {
                    // 쿠폰 사용 관련 메시지 처리
                    console.log("쿠폰 사용 메시지 수신:", body);
                    $bus.$emit(SocketMessageCode.CouponUsage, body);
                } else if (code == SocketMessageCode.CouponCycleUpdate) {
                    // 쿠폰 회차 정보 업데이트 처리
                    console.log("쿠폰 회차 정보 업데이트:", body);

                    // 사용자 정보 업데이트 (쿠폰 관련 필드)
                    if (principal.value) {
                        setPrincipal({
                            ...principal.value,
                            activeCouponId: body.activeCouponId,
                            rollingRequired: body.rollingRequired,
                            couponRolling: body.couponRolling,
                            cycleEligible: body.cycleEligible,
                        });
                    }

                    // 쿠폰 관련 컴포넌트들에게 업데이트 알림
                    $bus.$emit(SocketMessageCode.CouponCycleUpdate, body);

                    // 액션에 따른 알림 표시
                    if (body.action === "coupon_used") {
                        setAlert({
                            isShow: true,
                            data: {
                                type: "success",
                                message: "쿠폰이 성공적으로 사용되었습니다.",
                            },
                        });
                    } else if (body.action === "withdraw_approved") {
                        setAlert({
                            isShow: true,
                            data: {
                                type: "success",
                                message: "출금이 승인되어 쿠폰 회차가 종료되었습니다.",
                            },
                        });
                    }
                } else if (code == SocketMessageCode.CouponIssued) {
                    // 쿠폰 발급 알림 처리
                    console.log("쿠폰 발급 알림 수신:", body);

                    // 쿠폰 관련 컴포넌트들에게 업데이트 알림
                    $bus.$emit(SocketMessageCode.CouponIssued, body);

                    // 쿠폰 발급 성공 알림 표시
                    setAlert({
                        isShow: true,
                        data: {
                            type: "success",
                            message: `새로운 쿠폰이 발급되었습니다: ${body.couponIssue?.coupon_master?.name || "쿠폰"}`,
                        },
                    });
                } else if (code == SocketMessageCode.HeartBeat) {
                    console.log("received hearbeat");
                }
            } else {
                // console.error(`invalid socket message ::: ${JSON.stringify(data)}`);
            }
        });

        onBeforeMount(() => {
            heartbeatInterval = setInterval(() => {
                $io.emit($config.public.socket.clientChannel, {
                    code: SocketMessageCode.HeartBeat,
                });
                // console.log('heartbeat sent');
            }, 10000);
        });
        onBeforeUnmount(() => {
            clearInterval(heartbeatInterval);
        });

        watch(
            () => authentication.value.authenticated,
            (current, previous) => {
                console.log(`authenticated status change :: ${previous}----------->>>${current}`);
                if (previous != current && current == true) {
                    $io.disconnect();
                    if (authentication.value.jwt) {
                        $io.auth = { token: authentication.value.jwt };
                    }
                    $io.connect();
                    // $io.on('connect', () => {
                    //   console.log('verify socket connected');
                    // });

                    // $io.on('disconnect', (err: any) => {
                    //   console.log('verify socket disconnected', err);
                    //   $io.disconnect();
                    // });

                    // $io.on($config.public.socket.clientChannel, (data: SocketMessageType) => {
                    //   if (
                    //     data &&
                    //     Object.values(SocketMessageCode).some((x) => x == data.code) &&
                    //     data.body
                    //   ) {
                    //     const { code, body } = data;
                    //     console.log('received verify socket messsage');
                    //     if (code == SocketMessageCode.Prematch_Category) {
                    //       // setCategory(body);
                    //     } else if ( code == SocketMessageCode.Inplay_Fixture) {
                    //       $bus.$emit(SocketMessageCode.Inplay_Fixture, body);
                    //     } else if (code == SocketMessageCode.Prematch_Fixture) {
                    //       $bus.$emit(SocketMessageCode.Prematch_Fixture, body);
                    //     } else if (code == SocketMessageCode.Inplay_Market) {
                    //       $bus.$emit(SocketMessageCode.Inplay_Market, body);
                    //     } else if (code == SocketMessageCode.Prematch_Market) {
                    //       $bus.$emit(SocketMessageCode.Prematch_Market, body);
                    //     } else if (code == SocketMessageCode.Logout) {
                    //       console.log('logout message received');
                    //       if (!isAuthenticated) logout();
                    //     } else if (code == SocketMessageCode.HeartBeat) {
                    //       console.log('received hearbeat');
                    //     }
                    //   } else {
                    //     // console.error(`invalid socket message ::: ${JSON.stringify(data)}`);
                    //   }
                    // });
                }
            },
        );
    }
};
